import InputCheckbox from 'core/modules/atoms/InputCheckbox';
import PropTypes from 'prop-types';
import React from 'react';

function TreeViewToSelectLabel({ getChecked, isSelectable, item, onChange }) {
  return (
    <div className="tree-view-to-select-label">
      <div className="tree-view-to-select-label__checked">
        {isSelectable && <InputCheckbox disabled={item.isDisabled} checked={getChecked(item)} onChange={() => onChange(item)} />}

        <div className="tree-view-to-select-label__text" onClick={isSelectable ? () => onChange(item) : null}>
          <span className="title">{item.name}</span>
          <span className="description">{item.description}</span>
        </div>
      </div>
    </div>
  );
}

TreeViewToSelectLabel.propTypes = {
  getChecked: PropTypes.func,
  isSelectable: PropTypes.bool,
  item: PropTypes.object,
  onChange: PropTypes.func,
};

export default TreeViewToSelectLabel;
